import { LeadTimeOption, Shipment } from "../../../../reducers/uploadedBoard";
import { useUpdateShipments } from "../../../../utils/hooks/commonly-stored/uploaded-board/updates/shipments";
import React, { useState } from "react";
import {
  ShipmentActionContainer,
  ShipmentDetail,
  ShipmentsRowContainer,
} from "./ShipmentsStyles";
import { FakeLink, InputLabel } from "../../../../constants/Styles";
import LoadingOverlay from "../../../LoadingOverlay";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import Modal from "../../../common/Modal";
import { dateStringToHumanReadableDate } from "../../../../utils/valueFormatting";
import AddOrEditShipment from "./AddOrEditShipment";

export default function EditableShipmentRow({
  shipment,
  allowRemove,
}: {
  shipment: Shipment;
  allowRemove?: boolean;
}) {
  const { updatingShipDate, removeShipment } = useUpdateShipments();
  const [editingShipment, setEditingShipment] = useState<boolean>(false);

  const getSelectedDate = () => {
    if (shipment.ship_date !== null) {
      return shipment.ship_date;
    }
    return (
      shipment.lead_time_options.options.find((option) => {
        return option.base_days == shipment.base_lead_time_days;
      }) as LeadTimeOption
    ).ship_date;
  };

  return (
    <>
      <LoadingOverlay
        loading={updatingShipDate}
        text={"Updating lead time..."}
      />
      <ShipmentsRowContainer>
        <ShipmentDetail>
          <InputLabel>Number of boards</InputLabel>
          <div>{shipment.num_boards}</div>
        </ShipmentDetail>
        <ShipmentDetail>
          <InputLabel>Ship date</InputLabel>
          <div>{dateStringToHumanReadableDate(getSelectedDate())}</div>
        </ShipmentDetail>
        {allowRemove && (
          <ShipmentActionContainer>
            <FakeLink onClick={() => removeShipment(shipment.id)}>
              Remove
            </FakeLink>
          </ShipmentActionContainer>
        )}
        <ShipmentActionContainer>
          <FakeLink onClick={() => setEditingShipment(true)}>Edit</FakeLink>
        </ShipmentActionContainer>
        <Modal
          isOpen={editingShipment}
          onRequestClose={() => setEditingShipment(false)}
        >
          <ModalContentWithCloseButton
            closeModal={() => setEditingShipment(false)}
            title={"Edit shipment"}
          >
            <AddOrEditShipment
              shipmentId={shipment.id}
              onUpdate={() => setEditingShipment(false)}
            />
          </ModalContentWithCloseButton>
        </Modal>
      </ShipmentsRowContainer>
    </>
  );
}
